import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { useState } from "react";

export enum OptionNames {
  EmailSync = "Email Sync",
  DraftsForSalesAutomation = "Drafts for Sales Automation",
  Combo = "Combo",
}

const options = [
  {
    title: OptionNames.EmailSync,
    description:
      "Jarvis automatically syncs your external email threads to Zoho CRM Notes, so you don’t have to manually CC or forward emails anymore.",
    points: [
      "Hourly inbox scan",
      "Only external emails will be processed",
      "Threads linked to existing CRM contacts",
      "Notifications for unknown contacts",
      "Automatic saving of Gemini meeting notes to Zoho CRM Notes",
    ],
  },
  {
    title: OptionNames.DraftsForSalesAutomation,
    description:
      "Allow Jarvis to create Gmail drafts for you as part of Sales Automation.",
    points: ["Jarvis can auto-generate drafts", "You review and send manually"],
  },
  {
    title: OptionNames.Combo,
    description: "Best of both worlds — email sync + draft creation.",
    points: [
      "Sync your emails with Zoho CRM",
      "Auto-generate drafts for faster replies",
    ],
  },
];

export default function Subscribe() {
  const [selected, setSelected] = useState<null | number>(null);

  const handleConnect = () => {
    const params = new URLSearchParams({
      client_id:
        //  process.env.REACT_APP_NODE_ENV === "localhost"
        //   ? process.env.REACT_APP_GOOGLE_CLIENT_ID ?? "" :
        "985712802242-vd86g32olgono3ogdrnbk01gb96t9bev.apps.googleusercontent.com",
      redirect_uri:
        process.env.REACT_APP_NODE_ENV === "localhost"
          ? "http://localhost:3000"
          : "https://jarvis-assistant.agileengine.com",
      response_type: "code",
      scope:
        options[selected!].title === OptionNames.EmailSync
          ? "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/drive.readonly"
          : options[selected!].title === OptionNames.DraftsForSalesAutomation
            ? "https://www.googleapis.com/auth/gmail.compose https://www.googleapis.com/auth/gmail.settings.basic"
            : "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/gmail.compose https://www.googleapis.com/auth/gmail.settings.basic",
      access_type: "offline",
      prompt: "consent",
    });

    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography
        variant='h2'
        align='center'
        sx={{ fontWeight: "bold" }}
        mb={4}
      >
        Connect your Gmail with Jarvis
      </Typography>

      <Grid container spacing={3} justifyContent='center'>
        {options.map((opt, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              onClick={() => setSelected(index)}
              sx={{
                cursor: "pointer",
                border:
                  selected === index
                    ? "2px solid #ffab40"
                    : "1px solid #e0e0e0",
                borderRadius: 2,
                transition: "0.3s",
                height: "100%",
                "&:hover": {
                  boxShadow: 4,
                },
              }}
            >
              <CardContent>
                <Typography variant='h3' gutterBottom mb='16px'>
                  {opt.title}
                </Typography>
                <Typography variant='body1' paragraph>
                  {opt.description}
                </Typography>
                <ul
                  style={{ margin: 0, paddingLeft: "20px", fontSize: "18px" }}
                >
                  {opt.points.map((point, i) => (
                    <li key={i}>
                      <Typography variant='body2' sx={{ fontSize: "14px" }}>
                        {point}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {selected !== null && (
        <Box textAlign='center' mt={4}>
          <Button
            variant='contained'
            color='primary'
            size='large'
            onClick={handleConnect}
          >
            Continue with {options[selected].title}
          </Button>
        </Box>
      )}
    </Box>
  );
}
